
import React from 'react'

// components
import {
  CCol,
  CFormLabel,
  CFormSelect
} from '@coreui/react-pro'

const FormSelectInput = ({
  id,
  name,
  colSize,
  className,
  inputLabel,
  selectOptions,
  value,
  handleSelectInput,
  feedbackInvalid,
  invalid,
  disabled,
  noOptionText = "No Option",
}) => {
  return (
    <CCol lg={colSize} className={className}>
      <CFormLabel>
        {inputLabel}
      </CFormLabel>
      <CFormSelect
        id={id}
        name={name}
        multiple={false}
        onChange={(e) => handleSelectInput(e)}
        value={value}
        feedbackInvalid={feedbackInvalid}
        invalid={invalid}
        disabled={disabled}
      >
        {selectOptions.length > 0 ? (
          selectOptions.map((option) => (
            <option key={option.value} value={option.value}>
              {option.label}
            </option>
          ))
        ) : (
          <option value="" disabled>
            {noOptionText}
          </option>
        )}
      </CFormSelect>
    </CCol>
  )
}

export default FormSelectInput
